﻿import { Pipe, PipeTransform, Injectable } from "@angular/core";
import { SubjectNamePipe } from '@app/common/pipes/subject-name.pipe';
import { SubjectModel } from '@app/common/models/subject.model';
/**
 * Display name of project subject
 */
@Pipe({
  name: 'expertName',
  pure: false,
})
@Injectable({
  providedIn: 'root'
})
export class ExpertNamePipe implements PipeTransform {

  constructor(
    private subjectNamePipe: SubjectNamePipe,
  ) {}

  transform(subject: any) {
    if (!subject) {
      return '';
    }
    let name = this.subjectNamePipe.transform(subject);

    if (subject.kancelar) {
      name += ' (' + subject.kancelar + ')';
    }

    return name;
  }
}

